import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import Services from '../services/Services'
import TrackMap from '../components/TrackMap'

function Track(props) {
  const [theme, setTheme] = React.useState('')
  useEffect(() => {
    if (theme !== props.theme) {
      setTheme(props.theme)
    }
  }, [props.theme])

  const [order, setOrder] = useState({})
  const [orderId, setOrderId] = useState(0)
  const [prepMeal, setPrepMeal] = useState(0)
  const [active_flags, setActiveFlags] = useState({})
  const [driver, setDriver] = useState({})
  let location = useLocation()
  const services = new Services(this)
  const [orderTotal, setOrderTotal] = useState(0)

  const [commissions, setCommissions] = useState({
    delivery_fee: 0,
    tip: 0,
    service_fee: 0,
    hosting_fee: 0,
    coupon_amount: 0,
    discount: 0,
    tax: 0,
  })

  useEffect(() => {
    let orderId = 0
    try {
      orderId = isNaN(parseInt(localStorage.getItem('currentOrderId')))
        ? 0
        : parseInt(localStorage.getItem('currentOrderId'))
    } catch (error) {
      console.log(error)
    }
    if (orderId === 0) {
      window.location.href = '/not-found'
      return
    }

    let prepMeal = 0
    try {
      prepMeal = isNaN(parseInt(localStorage.getItem('currentOrderIsPrepMeal')))
        ? 0
        : parseInt(localStorage.getItem('currentOrderIsPrepMeal'))
    } catch (error) {
      console.log(error)
    }

    setPrepMeal(prepMeal)
    setOrderId(orderId)
    services.getOrder(orderId, prepMeal).then((data) => {
      if (data?.resultcode === 1) {
        let f_accepted = false
        let f_ready = false
        let f_dispatched = false
        let f_delivered = false
        setOrder(data)
        setOrderTotal(data.order.total ?? 0)
        if (data?.order_details?.status === 'accepted') {
          f_accepted = true
          f_ready = false
          f_dispatched = false
          f_delivered = false
        }
        if (
          data?.order_details?.status === 'ready' ||
          data?.order_details?.status === 'arrived_at_merchant'
        ) {
          f_accepted = true
          f_ready = true
          f_dispatched = false
          f_delivered = false
        }
        if (
          data?.order_details?.status === 'dispatched' ||
          data?.order_details?.status === 'enroute_to_customer' ||
          data?.order_details?.status === 'arrived_at_customer'
        ) {
          f_accepted = true
          f_ready = true
          f_dispatched = true
          f_delivered = false
        }
        if (data?.order_details?.status === 'delivered') {
          f_accepted = true
          f_ready = true
          f_dispatched = true
          f_delivered = true
        }
        setActiveFlags({
          f_accepted: f_accepted,
          f_ready: f_ready,
          f_dispatched: f_dispatched,
          f_delivered: f_delivered,
        })

        setCommissions({
          delivery_fee: data.order_details.delivery_fee ?? 0,
          tip: data.order_details.tip ?? 0,
          service_fee: data.order_details.admin_commission ?? 0,
          coupon_amount: data.order_details.coupon_amount ?? 0,
          discount: data.order_details.discount ?? 0,
          hosting_fee: data.order_details.hosting_fee ?? 0,
          maintenance_fee: data.order_details.maintenance_fee ?? 0,
          tax: data.order_details.tax ?? 0,
        })
      }
    })
    services.getDriver(orderId, prepMeal).then((data) => {
      if (data?.resultcode === 1) {
        setDriver(data)
      }
    })
  }, [])

  return (
    <div className={theme && theme === 'DARK' ? 'dark_theme' : 'light_theme'}>
      <div
        className="main-wrapper inner--page"
        style={{ backgroundColor: '#eff0f2' }}
      >
        <section className="order-location-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-md-12 col-sm-12">
                <div className="delivery-location">
                  <TrackMap
                    lat={order?.order_details?.latitude ?? 0}
                    lng={order?.order_details?.longitude ?? 0}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12">
                <div className="your-order-card track-order">
                  <div className="card-head">
                    <h6>Tracking your order from </h6>
                    <h4>{driver?.restaurant_name}</h4>
                  </div>
                  <div className="order-listing">
                    <ul>
                      <li className={active_flags?.f_accepted ? 'active' : ''}>
                        <p>
                          <img
                            src="/images/timepeice.png"
                            width="24"
                            height="24"
                            alt="Time Peice"
                          />{' '}
                          Order Accepted
                        </p>
                        <div className="date-time">
                          <img
                            src="/images/timer--icn.svg"
                            width="20"
                            height="20"
                            alt="Timer Icon"
                          />
                          <span>
                            {order?.order_details?.accepted_at
                              ? order?.order_details?.accepted_at
                              : 'Your order could take up to 5 minutes to display an "Accept" notification. We appreciate your patience'}
                          </span>
                        </div>
                      </li>
                      <li className={active_flags?.f_ready ? 'active' : ''}>
                        <p>
                          <img
                            src="/images/kitchen.png"
                            width="24"
                            height="24"
                            alt="kitchen"
                          />{' '}
                          In the Kitchen
                        </p>
                        <div className="date-time">
                          <img
                            src="/images/timer--icn.svg"
                            width="20"
                            height="20"
                            alt="Timer Icon"
                          />
                          <span>{order?.order_details?.ready_at}</span>
                        </div>
                      </li>
                      <li
                        className={active_flags?.f_dispatched ? 'active' : ''}
                      >
                        <p>
                          <img
                            src="/images/scooter.png"
                            width="24"
                            height="24"
                            alt="Scooter"
                          />{' '}
                          Out for delivery
                        </p>
                        <div className="date-time">
                          <img
                            src="/images/timer--icn.svg"
                            width="20"
                            height="20"
                            alt="Timer Icon"
                          />
                          <span>{order?.order_details?.sent}</span>
                        </div>
                      </li>
                      <li className={active_flags?.f_delivered ? 'active' : ''}>
                        <p>
                          <img
                            src="/images/home-icn.png"
                            width="24"
                            height="24"
                            alt="Home"
                          />{' '}
                          Delivered BY
                        </p>
                        <div className="date-time">
                          <img
                            src="/images/timer--icn.svg"
                            width="20"
                            height="20"
                            alt="Timer Icon"
                          />{' '}
                          <span>In 15 minutes</span>
                        </div>
                        <div className="date-time">
                          <span>
                            Clearance Code: {order?.order_details?.clearance}
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                {driver &&
                  driver.driver_details &&
                  (order?.order_details?.status === 'enroute_to_customer' ||
                    order?.order_details?.status === 'dispatched') && (
                    <div className="delivery-instruction">
                      {driver &&
                        driver.driver_details &&
                        (order?.order_details?.status ===
                          'enroute_to_customer' ||
                          order?.order_details?.status === 'dispatched') && (
                          <div className="delivery-guy-info">
                            <div className="profile-img">
                              <img
                                src={
                                  driver?.driver_details?.image
                                    ? 'https://roadjockey.com/images_fd/' +
                                      driver?.driver_details?.image
                                    : '/images/scooter.png'
                                }
                                width="40"
                                height="40"
                                alt="Delivery guy"
                              />
                              <p>
                                Message your Delivery guy,{' '}
                                <b>{driver?.driver_details?.first_name}</b>, for
                                more info:
                              </p>
                            </div>
                            {/* <div className="contact-number">
													<a href={"tel:"+driver?.driver_details?.phone_number} className="colorgreen"><i className="fa fa-phone-square"></i> {driver?.driver_details?.phone_number}</a>
												</div> */}
                            <div className="contact-number">
                              <a
                                href={
                                  'https://roadjockey.com/account/driver/order_chat?order_id=' +
                                  orderId +
                                  '&user_id=' +
                                  order?.order_details?.client_id +
                                  '&role=customer'
                                }
                                className="colorgreen"
                              >
                                <i className="fas fa-comments"></i>
                              </a>
                            </div>
                          </div>
                        )}
                      <div className="del-ins-content d-none">
                        <div className="instrcution-block">
                          <h6>ARRIVING IN</h6>
                          <h3>15 mins</h3>
                          <a href="#" className="transparent-green-btn">
                            Reschedule Delivery
                          </a>
                        </div>
                        <div className="instrcution-block">
                          <h6>DELIVERY ADDRESS</h6>
                          <p>
                            116 New Montgomery St San
                            <br /> Francisco Ca 94105
                          </p>
                          <a href="#" className="transparent-green-btn">
                            Change Address
                          </a>
                        </div>
                        <div className="instrcution-block">
                          <h6>DELIVERY INSTRUCTIONS</h6>
                          <p>{order?.order_details?.delivery_description}</p>
                          <a href="#" className="transparent-green-btn">
                            Edit Instructions
                          </a>
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            </div>
            <div className="row">
              <div className="col-lg-8 col-md-12 col-sm-12">
                <div className="your--order-reciept">
                  <div className="delivery-guy-info border-bottom">
                    <div className="profile-img">
                      <h4>Your Order</h4>
                    </div>
                    <div className="contact-number">
                      <span>Order No #{order?.order_details?.receiptno}</span>
                      <span>Date: {order?.order_details?.created_at}</span>
                      {/* <a href="#" className="colorgreen"><img src="/images/fontisto_print.png" width="18" height="19" alt="print icon" /> Print Recipt</a> */}
                    </div>
                  </div>
                  <div className="receipt-price-list">
                    <div className="order-listing">
                      <ul>
                        {order?.order_items?.map((item, index) => {
                          return (
                            <li key={index}>
                              <p>
                                <span>{item.quantity}x</span> {item.meal_name}
                              </p>
                              <p>JMD ${item.quantity * item.price}</p>
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12">
                <div className="your--order-reciept total-cost mb-5">
                  <div className="receipt-price-list">
                    <div className="order-listing">
                      <div className="totalcost-header">
                        <h4>Total Cost</h4>
                        <p>
                          <img
                            src="/images/questionmark.png"
                            width="18"
                            height="17"
                            alt="Question Mark"
                          />{' '}
                          Need Help?
                        </p>
                      </div>

                      <ul>
                        <li>
                          <p>Item subtotal:</p>
                          <p>
                            JMD $<b>{orderTotal}</b>
                          </p>
                          {commissions.delivery_fee > 0 ? (
                            <p>Discount: {commissions.discount}%</p>
                          ) : (
                            ''
                          )}
                        </li>
                        <li>
                          <p>Delivery fee:</p>
                          <p>JMD ${commissions.delivery_fee ?? 0}</p>
                        </li>
                        <li>
                          <p>Service fee:</p>
                          <p>JMD ${commissions.service_fee ?? 0}</p>
                        </li>
                        <li>
                          <p>Hosting fee:</p>
                          <p>JMD ${commissions.hosting_fee ?? 0}</p>
                        </li>
                        <li className="border-bottom">
                          <p>Tax:</p>
                          <p>JMD ${commissions.tax ?? 0}</p>
                        </li>
                        <li className="border-bottom">
                          <p>Driver tip:</p>
                          <p>JMD ${commissions.tip ?? 0}</p>
                        </li>
                        <li className="border-bottom">
                          <p>Coupon Amount:</p>
                          <p>JMD ${commissions.coupon_amount ?? 0}</p>
                        </li>
                        <li className="total-cost-bal">
                          <p>
                            <b>Total Cost</b>
                          </p>
                          <p>
                            <b>
                              JMD $
                              {parseInt(
                                (orderTotal * (100 - commissions.discount)) /
                                  100,
                              ) +
                                parseFloat(commissions.delivery_fee) +
                                parseFloat(commissions.tip) +
                                parseFloat(commissions.tax) +
                                parseFloat(commissions.hosting_fee) +
                                parseFloat(commissions.service_fee) -
                                parseFloat(commissions.coupon_amount)}
                            </b>
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}
export default Track
